// Tady si backendista jen změní doménu na svoji
const API_BASE_URL = "https://tvujweb.cz/api"; 

export const API_ENDPOINTS = {
    REGISTER: `${API_BASE_URL}/register.php`,
    LOGIN: `${API_BASE_URL}/login.php`,
    ORDER: `${API_BASE_URL}/uloz_objednavku.php`,
    PRODUCTS: `${API_BASE_URL}/get_products.php`,
    AUCTION_BID: `${API_BASE_URL}/bid.php`
};